import { Component } from '@angular/core';
import { ORCIDWorkExternalIDEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Work External IDs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidworkexternalid-form',
    templateUrl: './orcidworkexternalid.form.component.html'
})
export class ORCIDWorkExternalIDFormComponent extends BaseFormComponent {
    public record!: ORCIDWorkExternalIDEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

